export default __webpack_public_path__ + "static/media/icon_row.c799a5a9.svg";